import { forwardRef, type Ref, type SVGProps } from "react";
const IconCloseOutlineSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M25.9 7.515A1 1 0 0 0 24.485 6.1L16 14.586 7.515 6.1A1 1 0 0 0 6.1 7.515L14.586 16 6.1 24.485A1 1 0 1 0 7.515 25.9L16 17.414l8.485 8.486a1 1 0 0 0 1.415-1.415L17.414 16z" /></svg>;
const ForwardRef = forwardRef(IconCloseOutlineSVG);
ForwardRef.displayName = "IconCloseOutline";
export { ForwardRef as IconCloseOutline };